import { executeClientAction, ClientActionBaseContext, ExecuteClientActionResult } from "modules/record/shared/services/clientActionRuntime";


export const executeRecordListScript = async (
    script: string,
    context: ClientActionBaseContext,
    records: any[],
    table: any,
    mode: "list" | "related_list" = "list",
    timeoutMs?: number | string | null
): Promise<ExecuteClientActionResult> => {
    return executeClientAction({
        script,
        mode,
        baseContext: context,
        records,
        table,
        tableName: table?.name,
        timeoutMs,
    });
};
